export default __webpack_public_path__ + "public/assets/images/250208d25e6c69ad417e1def7e3765f7.png";